import { useReducer, useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash';
import useApi from 'hooks/useApi';
import lookupEndpoints from './lookup-endpoints';
import { initialState, reducer } from './reducer';
import * as ACTIONS from './actions';

export default dashboardType => {
  const [dashboardsState, dispatch] = useReducer(reducer, initialState);
  const { dashboardTypesLookupValues } = dashboardsState;

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError, error } = state;

  const hasDashboardTypeLookupValues =
    !isEmpty(dashboardTypesLookupValues) && !isEmpty(dashboardTypesLookupValues[dashboardType]);

  const dashboardTypeIdValues =
    hasDashboardTypeLookupValues && dashboardTypesLookupValues[dashboardType];

  useMemo(() => {
    // Don't send api request if the lookup values for this dashboardTypesLookupValues have been extracted since we can use them from the reducers state
    if (hasDashboardTypeLookupValues) return;

    const reqParams = lookupEndpoints[dashboardType];
    makeRequest(reqParams);
  }, [dashboardType, hasDashboardTypeLookupValues, makeRequest]);

  useEffect(() => {
    if (isLoading) return;

    if (isError) return;

    if (data) {
      dispatch({
        type: ACTIONS.SET_DASHBOARD_LOOKUP_TYPES,
        payload: { data, id: dashboardType }
      });
    }
  }, [isLoading, isError, error, data]); // eslint-disable-line react-hooks/exhaustive-deps

  return [state, dashboardTypeIdValues];
};
